import React from 'react';
import { aboutContent } from '../data/mock';
import { Heart, Eye, BookOpen } from 'lucide-react';

export const About = () => {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            {aboutContent.title}
          </h2>
          <p className="font-playfair text-2xl md:text-3xl text-amber-800 italic max-w-3xl mx-auto leading-relaxed">
            "{aboutContent.quote}"
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          {/* Image */}
          <div className="relative group">
            <div className="overflow-hidden rounded-2xl shadow-2xl">
              <img
                src={aboutContent.image}
                alt="Kibouor Community"
                className="w-full h-[500px] object-cover transform transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 rounded-2xl ring-2 ring-amber-400/20 ring-offset-4"></div>
          </div>

          {/* Text Content */}
          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              {aboutContent.description}
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              {aboutContent.story}
            </p>
          </div>
        </div>

        {/* Mission, Vision, Values */}
        <div className="grid md:grid-cols-3 gap-8">
          {/* Mission */}
          <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 border-t-4 border-amber-500">
            <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center mb-6">
              <Heart className="h-7 w-7 text-amber-600" />
            </div>
            <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
            <p className="text-gray-700 leading-relaxed">{aboutContent.mission}</p>
          </div>

          {/* Vision */}
          <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 border-t-4 border-amber-600">
            <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center mb-6">
              <Eye className="h-7 w-7 text-amber-600" />
            </div>
            <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
            <p className="text-gray-700 leading-relaxed">{aboutContent.vision}</p>
          </div>

          {/* Story */}
          <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 border-t-4 border-amber-700">
            <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center mb-6">
              <BookOpen className="h-7 w-7 text-amber-600" />
            </div>
            <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-4">Our Story</h3>
            <p className="text-gray-700 leading-relaxed">
              A movement born from compassion, powered by AR Holdings Group's vision for humanity.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};